<template>
  <div class="mainContainer">
    <el-tabs v-model="activeName">
      <el-tab-pane label="社区规范" name="first">
        <p class="label">顶端新闻社区规范</p>
        顶端新闻希望为内容创作者提供公平、健康、和谐的创作环境，同时也致力于为广大用户提供良好的阅读体验和交流环境，共创健康、活跃、有序的平台内容生态。
        <br />希望每一位顶端用户能够阅读并遵循本规范。如果您的发布、评论、推广等行为与本规范冲突，将可能无法通过审核或被限制推荐展示。情节严重的，平台将对账号采取警告、禁言、账号重置、封禁、关闭收益权限等处置措施。
        <br />本规范的上线及更新，平台将通过顶端新闻APP以及顶端创作者平台网页进行展示，展示后即视为平台已通知用户。您随时可以查询最新内容。
        <p class="label">一、用户行为规范</p>
        平台禁止任何恶意损害平台权益、扰乱平台正常运营秩序的行为或内容，包含但不限于以下情况：
        <br />1、不以真实身份信息注册，或者注册与自身真实身份信息不相符的账号名称、头像、简介等；
        <br />2、恶意假冒、仿冒或者盗用组织机构及他人公众账号生产发布信息内容；
        <br />3、未经许可或者超越许可范围提供互联网新闻信息采编发布等服务；
        <br />4、操纵利用多个平台账号，批量发布雷同低质信息内容，生成虚假流量数据，制造虚假舆论热点；
        <br />5、利用突发事件煽动极端情绪，或者实施网络暴力损害他人和组织机构名誉，干扰组织机构正常运营，影响社会和谐稳定；
        <br />6、编造虚假信息，伪造原创属性，标注不实信息来源，歪曲事实真相，误导社会公众；
        <br />7、以有偿发布、删除信息等手段，实施非法网络监督、营销诈骗、敲诈勒索，谋取非法利益；
        <br />8、违规批量注册、囤积或者非法交易买卖账号；
        <br />9、通过低质、工业化内容创作和黑灰产团伙行为等，在平台恶意博取流量，以流量变现为唯一目的、将内容视为获取流量工具；
        <br />10、制作、复制、发布违法信息，或者未采取措施防范和抵制制作、复制、发布不良信息；
        <br />11、通过摆拍、虚构情节、剧情演绎等方式散布虚假信息、恶意炒作争议事件、煽动对立情绪，打造虚假人设；
        <br />12、法律、行政法规或平台应禁止的其他行为。
        <p class="label">二、内容创作规范</p>
        1、禁止国家法律法规和相关政策明令禁止的行为或内容
        <br />（1）反对宪法所确定的基本原则，煽动抗拒或者破坏宪法、法律、行政法规实施的；
        <br />（2）危害国家安全，泄露国家秘密，颠覆国家政权，破坏国家统一、主权和领土完整的；
        <br />（3）损害国家荣誉和利益的；
        <br />（4）诋毁民族优秀文化传统，侵害民族风俗习惯，煽动民族仇恨、民族歧视，破坏民族团结的；
        <br />（5）破坏国家宗教政策，宣扬宗教狂热，危害宗教和睦，伤害信教公民宗教感情，破坏信教公民和不信教公民团结，宣扬邪教和封建迷信的；
        <br />（6）散布谣言，危害社会公德，扰乱社会秩序，破坏社会稳定的；
        <br />（7）散布淫秽、色情、赌博、吸毒、暴力、凶杀、恐怖或者教唆犯罪的；
        <br />（8）侮辱或者诽谤他人，侵害他人合法权益的；
        <br />（9）宣扬恐怖主义、极端主义的；
        <br />（10）侵害未成年人合法权益或者损害未成年人身心健康的；
        <br />（11）含有法律、行政法规、规章、条例或其他具有法律效力规范禁止的其他内容的。
        <br />2、禁止损害党和国家、领导人、英雄烈士的内容
        <br />（1）使用国家机关的名称、标志或国家领导人形象作为个人资料、头像、昵称、标题等；
        <br />（2）玷污、毁损、使用不正确的国旗、国徽、党旗、党徽、党员徽章、地图等的；
        <br />（3）谈论影响社会和谐的时政敏感话题的，如时事政治、境外内容、政府部门、军事警备、重大事故；
        <br />（4）歪曲诋毁或歧视宗教观念、宗教信仰的；
        <br />（5）歪唱国歌、革命歌曲的；
        <br />（6）非官方以官方政府、解放军、武警部队等名义作宣传；
        <br />（7）诋毁、诽谤、侮辱、损害英雄烈士的。
        <br />3、禁止涉及危害人身、财产、公共安全内容
        <br />（1）散布暴力、恐怖、血腥、危害人身安全或者教唆犯罪的；
        <br />（2）展示或传播枪支（含仿真枪）、管制刀具的；
        <br />（3）传播、引诱、教唆他人吸食毒品，讲解毒品制作过程等一切与毒品相关的；
        <br />（4）直播或间接传播淫秽有害信息的；
        <br />（5）组织、宣传、哄骗用户加入传销机构的；
        <br />（6）教授赌博技巧、参与赌博活动、宣传赌博行为的；
        <br />（7）利用游戏、红包、道具等变相进行赌博的；
        <br />（8）展示和捕杀动物的，包括但不限于捕猎珍稀动植物、捕鱼电鱼炸鱼、破坏海洋资源和生态环境等。
        <br />4、禁止淫秽色情、低俗内容
        <br />（1）低俗图片和信息（涉黄、涉性、露点图片）、色情动漫内容；
        <br />（2）着装、动作、声音、文字、道具、拍摄场所等表现或者隐晦表现性行为、令人产生性联想、具有挑逗性或者侮辱性的内容；
        <br />（3）包含对性行为、性过程、性方式的描述或者带有性暗示、性挑逗的内容；
        <br />（4）包含对性部位描述、暴露、马赛克，或者只用很小的遮盖物进行掩饰的内容；
        <br />（5）穿着情趣制服、情趣内衣、透视装、肉色紧身衣、真空凸点等衣着不整的；
        <br />（6）包含全身或者隐私部位未着衣物，仅用肢体掩盖隐私部位的内容；
        <br />（7）含勾引、约炮等隐晦性的低俗内容，诱惑性及暧昧引人遐想的词汇；
        <br />（8）带有明显性暗示的抚摸、舔咬、拉扯动作、性挑逗性质的表演；
        <br />（9）着装、言语等低俗暴露，带有性暗示、性挑逗或其他低级趣味的行为；
        <br />（10）其他涉及传播淫秽低俗信息的情形。
        <br />5、不得无资质发布专业内容
        <br />（1）未取得互联网新闻信息服务许可，不得发布新闻信息。新闻信息指：时政类新闻信息，包括有关政治、经济、商贸、金融、军事、外交、文化、民生、公益、社会活动等社会公共事务的报道、评论，以及有关社会突发事件的报道、评论；
        <br />（2）未申请取得健康类专业资质认证的个人和机构，不得发布疾病治疗、用药指导等健康领域专业性强的内容；
        <br />（3）未申请取得财经类专业资质认证的个人和机构，不得发布股票买卖指导、投资指南等财经领域专业性强的内容；
        <br />（4）我国法律法规要求必须取得特定资质方可从事特定行为的其他情形，依该等法律法规要求处理。
        <br />6、禁止违规推广宣传
        <br />（1）借领导人/重大会议营销，借国家重大会议或领导人形象、名号等为企业或产品宣传推广；
        <br />（2）宣传传销组织、违规网贷、网赚刷单等，或不合规的汽车、烟草、彩票等相关推广行为；
        <br />（3）荐股荐彩，推荐购买指定的股票、博彩（包含彩票、六合彩、赌球、跑马）等高风险投资产品，吸引他人跟进购买；
        <br />（4）诱导投资，诱导他人参与投资的各类推广话术，包括但不限于P2P、区块链、各种网赚等；
        <br />（5）未经平台允许，展示、口播联系方式、二维码、QQ群号、网址、论坛地址等；
        <br />（6）未经平台允许，发布外部商品信息或引导、暗示观众选购外部网站商品、私下/线下交易的；
        <br />（7）未经平台允许，有明显商业化宣传、商业化标识或logo露出、导流、营销行为的；
        <br />（8）发布广告信息、含广告销售意图的信息，如“找我购买”“私信我购买”“可代购”等；
        <br />（9）内容拼凑或重复，前后内容没有衔接，无关内容占比较大；
        <br />（10）发布恶意营销、重复相似内容，低质量内容，影响用户体验的内容。
        <br />7、禁止侵犯他人合法权益
        <br />（1）损害他人名誉、荣誉、肖像、姓名、隐私、个人信息等合法权益；
        <br />（2）内容侵犯他人著作权、商标权、专利权、商业秘密等知识产权的情形；
        <br />（3）推广假冒注册商标商品、盗版商品，或者存在为出售假冒注册商标、盗版商品提供帮助、便利条件等内容的信息；
        <br />（4）未经许可使用顶端品牌及顶端产品，冒充顶端代理商、工作人员等；
        <br />（5）公开披露、泄露他人商业秘密；
        <br />（6）对商家、用户等进行不正当竞争、扰乱竞争秩序的；
        <br />（7）转发不实报道、未经证实的内容给他人造成损害的；
        <br />（8）其他侵犯他人合法权益的情形。
        <br />8、禁止以虚假或引人误解的内容欺骗、误导用户
        <br />（1）冒用他人身份，通过头像、昵称、简介等内容暗示自己与他人或机构存在关系；
        <br />（2）散布谣言、虚假内容、无事实依据的、与事实相悖或违背科学常理，凭空杜撰、拼凑、编造或曲解事实，制造耸人听闻的内容；
        <br />（3）分享虚假夸大、假冒伪劣、以次充好的产品或服务；
        <br />（4）夸张宣传、虚假承诺、误导诱骗消费；
        <br />（5）无可信来源，断章取义或以讹传讹，存在诋毁、人身攻击等负面影响的；
        <br />（6）发布内容与事实不一致、关键信息不准确，或歪曲事实等行为；
        <br />（7）通过摆拍、虚构情节、剧情演绎等方式散布虚假信息、恶意炒作争议事件、煽动对立情绪，打造虚假人设，违反法律法规，违背公序良俗的；
        <br />（8）用户发布含有虚构情节、剧情演绎内容，却不进行虚构演艺标识注明的；
        <br />（9）其他有虚假夸大、失实或引人误解的内容。
        <br />9、禁止违背社会公序良俗、有不良影响的内容
        <br />（1）内容中出现血腥、暴力、恶心、猎奇、密集恐惧、令人产生恐惧或引人不适反感的，包括但不限于尸体、肢体、内脏器官、排泄物、体验恶心食物、虐待动物等；
        <br />（2）虚假、过度夸张、博眼球的；
        <br />（3）自行或煽动用户对他人进行暴力恐吓、威胁、侮辱谩骂、嘲讽、地域/人身/攻击、歧视的；
        <br />（4）恶意引战、煽动用户情绪、发布仇恨言论、不友善行为、其他有组织行为的；
        <br />（5）涉及不雅词汇、迷信、谣言、恶心、恐怖、暴力以及违背社会主流价值观的内容；
        <br />（6）其他有害平台健康运营的内容。
        <br />10、禁止各种作弊以及恶意营销等行为禁止滥用产品功能、生成式AI等手段，进行流量作弊，大量发布低质或工业化批量生产的内容，恶意刷粉刷赞，影响用户体验、破坏平台规则且损害他人权益的行为。包含但不限于以下场景：
        <br />（1）违规批量发文，或频繁发布抄袭搬运内容：
        <br />（2）批量发布重复内容：一段时间内，用非正常手段连续发布大量重复内容，或高度相似内容；
        <br />（3）批量发无意义/低质内容：连续或大量发布无意义元素，包括但不限于无意义图片、符号、表情、乱码、无序文字等；
        <br />（4）过预设模板、套路化的文案脚本，批量、工业化炮制各类主题、文案、画面、情节高度相似的同质化视频内容，或利用人工智能软件批量生产低质内容；
        <br />（5）通过开设并运营多个账号，形成“矩阵”，以实现更低成本的流量获取，矩阵号会在多个账号上同时推送相同或类似的内容，“大小号”相互引流，制造虚假热度；
        <br />（6）违规刷量：通过非正常手段进行作弊，获取虚假粉丝、虚假点赞数据的行为。
        <br />11、禁止历史虚无主义有害内容
        <br />呼吁各位创作者加强自我约束，警惕历史虚无主义的不良影响，正确认识“四史”，要坚持历史唯物主义的立场、观点、方法，要尊重历史事实、尊重历史规律，反对历史虚无主义。
        <br />12、禁止宣扬不良价值观
        <br />（1）挑战公序良俗或游走在社会道德边缘的行为；
        <br />（2）展示违背伦理道德的糜烂生活；
        <br />（3）宣扬不良生活方式和不良流行文化，渲染消极情绪，宣扬颓废的人生观、世界观和价值观；
        <br />（4）宣扬拜金主义和享乐主义；
        <br />（5）宣传和宣扬丧文化、自杀游戏；
        <br />（6）以肯定、赞许的基调或引入模仿的方式表现打架斗殴、羞辱他人、污言秽语；
        <br />（7）恶意对比、引战行为。 <br />13、不鼓励低质标题及低质内容
        <br />（1）通过夸张描述、隐瞒信息、扭曲原意、不知所云、挑衅恐吓、强迫诅咒、滥用转折、故弄玄虚、制造歧义、捏造事实、无中生有、模棱两可、表述不明等方式增加标题吸引力，引诱用户阅读，但与内文真实情况不符，造成用户阅读后心理落差与不良体验的；
        <br />（2）封面与标题不符：封面图与内容主体完全不相关，或封面图结合标题易使读者产生误解；
        <br />（3）标题滥用名称、题材不明确：标题未明确所涉及题材，滥用演员名代替剧中人物名，或用新闻式标题描述影视剧情节，引起歧义，误导用户认为是明星花边或社会时政负面；封面或配图内容质量差，与文章主体无关且不能为文章增补信息量；
        <br />（4）图文格式混乱或不美观，音画质量差等影响阅读体验；
        <br />（5）文章乱码、无段落或无标点；病句或错别字较多、乱码符号，有碍于读者理解内容。
        <br />14、不鼓励发布已过时效性内容
        <br />指发布并非新近发生的资讯、消息等本应有时效性的内容，且因发布内容中时间不明确、隐藏时间词或时间词过期等引起读者理解偏差、混淆了事件的真实发生时间，容易引起阅读误解的。
        <br />15、不鼓励使用不规范表述
        <br />指涉及对于国家机构、人名地名、民族等表述不规范。包含但不限于：公众人物人名的错误书写；称呼政府为ZF，国家为GJ等；称呼“宁夏回族自治区”为“宁夏省”、称呼“内蒙古自治区”为“内蒙古省”、称呼“蒙古族”为“蒙族”等。
        <p class="label">三、违规处理措施</p>
        如用户在使用顶端新闻平台服务过程中存在以上违反规范的行为，一经发现，平台有权采取包括但不限于以下相应措施：
        <br />（1）警示：通过站内信等形式提醒违规情况，告知后如若继续违规则，则进行相应处罚；
        <br />（2）限制账号功能，如限制或禁止发布私信等；
        <br />（3）收回或冻结账号的等级、权益、收益等； <br />（4）禁言；
        <br />（5）账号封禁； <br />（6）删除违规内容或重置违规账号；
        <br />（7）限制流量分发； <br />（8）依法追究法律责任。
        <br />针对违规内容，如发文、评论、个人信息等，平台将采取建议修改、限制传播、下线删除等处置措施。
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
export default {
  data() {
    return {
      activeName: "first",
    };
  },
  created() {},
  mounted() {},
  methods: {},
};
</script>

<style lang="scss" scoped>
.mainContainer {
  border-radius: 8px;
  background-color: #fff;
  height: calc(100vh - 100px);

  /deep/.el-tabs {
    .el-tabs__nav-wrap::after {
      height: 1px;
      background-color: #EDF1F8;
    }

    .el-tabs__nav-scroll {
      padding-left: 33px;

      .el-tabs__item {
        line-height: 65px;
        height: 65px;
        color: #333333;
        font-size: 15px;
      }

      .el-tabs__item.is-active {
        color: #333333;
      }
    }

    .el-tabs__header {
      margin-bottom: 0;
    }

    .el-tabs__content {
      padding: 9px 33px 33px 33px;
      color: #333333;
      font-weight: 400;
      font-size: 14px;
      font-family: "PingFang SC";
      line-height: 20px;
      height: calc(100vh - 165px);
      overflow-y: auto;

      .label {
        color: #333333;
        font-size: 16px;
        font-weight: 500;
        font-family: "PingFang SC";
        line-height: 70px;
      }
    }
  }
}
</style>
